import { INpcInfo } from './chat';

export enum RoleRefType {
  Unknown = 0,
  NPC = 1,
}

export enum RolePlayStatus {
  Unknown = 0,
  Starting = 1,
  Challenging = 2,
  Cleared = 3,
  Failed = 4,
}

export interface GetCurrentRolePlayStoryInfoReq {
  role_play_id?: number;
}

export interface GetPlayStoryListReq {
  album_id?: number;
}

export interface RolePlayRole {
  role_id?: number;
  role_name?: string;
  role_avatar?: string;
  role_ref_type?: RoleRefType;
  role_ref_id?: number;
}

export interface RolePlayPrologue {
  role_id?: number; // 0-旁白
  content?: string;
  voice_url?: string;
  voice_duration_ms?: number;
  prologue_id?: number;
}

export interface RolePlayIPInfo {
  ip_name?: string;
  ip_desc?: string;
}

export interface RolePlayGoalInfo {
  goal_desc?: string;
}

export interface RolePlayChatBackgroundInfo {
  background_img_url?: string;
  background_music_url?: string;
  background_imgs?: Array<{ url: string; depth: string }>;
}

export interface RolePlayDescInfo {
  role_play_name?: string;
  role_play_outline?: string;
  role_play_og_recap?: string; // 原著回顾
  role_play_reinvention?: string;
}

export interface RolePlayProgressInfo {
  current_score?: number;
  total_score?: number;

  rounds_left: number; // 剩余回合数
  target_rounds: number; // 玩法总回合数
}

export interface RolePlayBasic {
  role_play_id?: number;
  desc_info?: RolePlayDescInfo;
  conver_url?: string;
  version?: number;
  roles?: RolePlayRole[];
  prologues?: RolePlayPrologue[];
  player_role_id?: number;
  ip_info?: RolePlayIPInfo;
  goal_info?: RolePlayGoalInfo;
  chat_background_info?: RolePlayChatBackgroundInfo;
}

export interface GetCurrentRolePlayStoryInfoResp {
  role_play_basic?: RolePlayBasic;
  role_play_status?: RolePlayStatus;
  role_play_progress?: RolePlayProgressInfo;
}

export interface NpcListInfo {
  npc_info: INpcInfo;
  background_img: string;
  statistic_info: {
    co_creator_count: number;
    followers_count: number;
    linkers_count: number;
  };
}

export interface RoleInfo {
  role_id: number;
  role_name: string;
  role_avatar: string;
  role_ref_npc_id: number;
}

export interface PlayInfo {
  chat_background_info: {
    background_img_url: string;
    background_music_url: string;
  };
  desc_info: RolePlayDescInfo;
  goal_info: RolePlayGoalInfo;
  ip_info: RolePlayIPInfo;
  role_play_id: number;
  player_role_id: number;
  play_preference: {
    background_color: string;
    cover_url: string;
    default_role_avatar: string;
  };
  prologues: GetRolePlayPrologueMsgVoiceReq;
  roles: RoleInfo[];
}

export interface SceneInfo {
  background_color: string;
  thumb_cover_url: string;
  title: string;
  achieve_count: number;
  desc: string;
  play_count: number;
  play_list: PlayInfo[];
}

export interface IRolePlayEmoji {
  emoji_id: number; // emoji 标识
  emoji: string; // 展示的emoji图标。后续如果要展示文字的话再加字段，避免理解成本
  short_title: string; // 默认的文案
}

export interface RolePlayStoryInfo {
  npc_list: NpcListInfo[];
  scene_list: SceneInfo[];
  background_cover_url: string;

  // album_type = NPCChat时额外返回的数据
  emoji_list_map?: Record<string, IRolePlayEmoji[]>; // emoji配置
  role_play_npc_list?: NpcListInfo[]; // 角色扮演列表，可以直接点进去聊天
  talk_to_npc_list?: NpcListInfo[]; // 去聊天的列表
  background_imgs: { url: string }[];
}

export interface RestartRolePlayReq {
  role_play_id?: number;
}

export interface GetRolePlayPrologueMsgVoiceReq {
  role_play_id?: number;
  prologue_id?: number;
}

export interface GetRolePlayPrologueMsgVoiceResp {
  prologue_voice_url?: string;
  prologue_voice_duration?: number;
}

export interface RestartRolePlayResp {}

export interface AcceptRolePlayMsgReq {
  user_id?: number;
  role_play_id?: number;
  //   msg?: EaseMobPayload;
  im_mid?: string;
}

export interface AcceptRolePlayMsgResp {
  mid?: number;
}

export interface GetPlayStoryAlbumReq {}

export enum AlbumType {
  Default = 0,
  NPCChat = 1,
}

export interface PlayStoryAlbum {
  album_id: number;
  album_name: string;
  tags?: string[];
  play_count?: number;
  scene_count?: number;
  cover_url: string;
  thumb_cover_url: string;
  album_type?: AlbumType;
}

export interface GetPlayStoryAlbumResp {
  album_list: PlayStoryAlbum[];
}

export interface GetPlayStoryListByAlbumReq {
  album_id: number;
}

export interface GetRolePlayRewardImgReq {
  role_play_id: number;
}

export interface GetRolePlayRewardImgResp {
  img_url?: string;
}

export interface GetRolePlayMsgVoiceReq {
  im_mid: string;
  role_play_id: number;
  role_id: number;
}

export interface GetRolePlayMsgVoiceResp {
  voice_uri: string;
  voice_duration_ms: number;
}

export interface ICreateRolePlayStoryReq {
  role_play_id: number;
  user_id: number;
  share_url: string;
}

export interface ICreateRolePlayStoryResp {
  role_play_user_story_id: number; // 用户角色扮演的故事id
}

export interface IGetRolePlayMessageListReq {
  role_play_user_story_id: number;
}

export interface IServerRolePlayMessage {
  ease_mob_mid: string;
  text: string;
  role_play_role_id: number;
  voice_uri: string;
  voice_duration_ms: number;
}

export interface IGetRolePlayMessageListResp {
  role_play_message_list: IServerRolePlayMessage[]; // 返回15轮对话
  role_play_basic: RolePlayBasic & { album_id: number }; // 基础信息
  share_url: string; // 分享图的链接
  owner_id: number;
}

export interface ReWriteEmojiReq {
  emoji_id: number;
  emoji_title: string;
  role_play_npc_id: number;
  talk_to_npc_id: number;
}

export interface ReWriteEmojiResp {
  emoji_title: string;
}

export enum IAlbumType {
  default,
  v2,
}

export interface IAlbumInfo {
  album_id: number;
  album_name: string;
  background_color: string;
  cover_url: string;
  thumb_cover_url: string;
  play_count: number;
  scene_count: number;
  album_type: IAlbumType;
}
